/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import "./Stamreeks.scss";
import React from "react";
import { GenealogySource, Parent } from "./Genealogy/types";
import { Stamreeks } from "./Stamreeks";
import { getLadageParents } from "./Stamreeksen/ladage";
import { getSources } from "./Genealogy/LadageSources";

export class StamreeksLadage extends React.Component<{}, { parents: Parent[] }> {
  sources: GenealogySource[] = [];
  constructor(props: {}) {
    super(props);
    this.initialize();
  }

  initialize = () => {
    getSources().then((sources) => {
      this.sources = sources;
      this.setState({ parents: getLadageParents(sources) });
    });
  };

  render() {
    if (!this.sources || !this.state || !this.state.parents) return <div />;

    const content = () => (
      <div>
        <h1>Stamreeks "Ladage"</h1>
        <p>
          Op deze pagina is de stamreeks uitgewerkt van 'mijn' familie Ladage. Een stamreeks toont een overzicht van iemands voorouders in de rechte mannelijke lijn. Bij het maken
          van een stamreeks ga je terug in de tijd tot de oudst bekende voorvader, dat is de stamvader. In het geval van deze familie Ladage is dat Nicolaus La Dague geboren in
          1438 (vermoedelijk in Sedan, Frankrijk).
        </p>
        <p>
          De informatie in dit overzicht is afkomstig uit vele bronnen, waaronder de diverse doopregisters die op internet te vinden zijn en de stambomen die op diverse genealogie
          websites gedeeld worden. Indien de bron van een bepaalde gebeurtenis bekend is, staat deze vermeld met behulp van eindnoten met linkjes naar een kopie van deze bron.
          Indien er geen bron vermeld is, heb ik deze informatie dus wel ergens gevonden maar daarvan geen 'bewijs' kunnen vinden in de vorm van een doopregister, overlijdensakte,
          enz. Bij die gebeurtenissen is er dus een kans dat het gewoonweg niet klopt.
        </p>
        <p>
          De oudste bron die ik terug heb kunnen vinden is een huwelijksakte uit 1583. De vier generaties die daarvoor staan vermeld in onderstaande stamreeks heb ik van Gegeanet,
          maar met de kanttekening dat ik daarbij geen aktes heb kunnen vinden waaruit deze feiten blijken.
        </p>
      </div>
    );

    return <Stamreeks content={content()} sources={this.sources} parents={this.state.parents} />;
  }
}
